import { SET_PANEL_DELIVERY_REPORTS } from './types';

export const setPanelDeliveryReports = (mode, data) => ({
    type: SET_PANEL_DELIVERY_REPORTS,
    payload: { mode, data },
});
